































































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { BvTableFieldArray, BvTableCtxObject } from 'bootstrap-vue';
import { Dayjs } from 'dayjs';
import { VIPCertificateRefreshTableMixin } from '@/mixins/VIPCertificateMixin';
import CertificatePdfModal from "./CertificatePdfModal.vue";
import IpSelect from "../ip/IpSelect.vue";
import {
	VIPProject,
	VIPCertificateRest,
	IVIPCertificate,
	VipCertificateStatus,
	VipCertificateType,
	getVipCertificateStatusList,
	getVipCertificateTypeList,
	VIPCertificate,
	VIPCapability,
	VIPIp,
	VIPUser,
	auth,
	VIPCertificateFields
} from "@/loader/public";

@Component({
	components: {
		CertificatePdfModal,
		IpSelect,
	},
})
export default class CertificatesTable extends Mixins(VIPCertificateRefreshTableMixin) {
	@Prop({ type: VIPProject, default: null })
	public project!: VIPProject | null;

	@Prop({ type: String, default: null })
	public status!: VipCertificateStatus | null;

	@Prop({ type: String, default: null })
	public pdfModalId!: string | null;

	@Prop({ type: VIPCapability, default: null })
	public capability!: VIPCapability;

	public types: VipCertificateType[] = [];
	public statuses: VipCertificateStatus[] = [];
	public certificate: VIPCertificate | null = null;
	public ips: number[] = [];
	public ips_relation: "AND" | "OR" = "OR";

	public get token() {
		return auth.token;
	}

	public selectCertificate(value: VIPCertificate | null) {
		this.certificate = value;
		this.$emit("select-certificate", value);
		if (!this.pdfModalId && value) {
			this.$nextTick(() => this.$bvModal.show(this.localPdfModalId));
			// this.$nextTick(() => this.$refs.viewer.show());
		}
	}

	public get localPdfModalId() {
		return this.pdfModalId || "certs_pdf_modal";
	}

	public get certificateStatuses() {
		return getVipCertificateStatusList();
	}

	public get certificateTypes() {
		return getVipCertificateTypeList();
	}

	public get fields(): BvTableFieldArray {
		let fields: BvTableFieldArray = [];
		fields.push({
			key: "id",
			label: "Certificats",
			sortable: !this.noSorting,
		});
		if (!this.project) {
			fields.push({
				key: "project",
				label: "Projets",
			});
		}
		fields.push({
			key: "ips",
			label: "IPs",
			tdClass: "badge-list",
		});
		if (!this.project) {
			fields.push({
				key: "project.manager",
				label: "Conducteur",
				formatter(value: VIPUser | null) {
					return value?.name || "";
				}
			});
		}
		fields.push({
			key: "date",
			label: "Signé",
			sortable: !this.noSorting,
			formatter(value: Dayjs | null) {
				return value?.format("L") || "";
			}
		});
		return fields;
	}

	public get statusVariant(): (item: IVIPCertificate) => string {
		return (item: IVIPCertificate) => {
			switch (item.status) {
				case VipCertificateStatus.draft:
					return "outline-secondary";
				case VipCertificateStatus.validating:
					return "outline-info";
				case VipCertificateStatus.checking:
					return "info";
				case VipCertificateStatus.sending:
					return "warning";
				case VipCertificateStatus.awaiting:
					return "outline-warning";
				case VipCertificateStatus.signed:
					return "success";
				case VipCertificateStatus.abandonned:
				default:
					return "outline-danger";
			}
		}
	}

	public get certificate_ips(): (item: IVIPCertificate) => VIPIp[] {
		return (item: IVIPCertificate) => {
			if (!item.ips || !item.ips.length) {
				return [];
			}
			return <VIPIp[]>item.ips.map(cip => cip.ip).filter(ip => ip).sort((a, b) => (a?.code || 0).toString().localeCompare((b?.code || 0).toString()));
		};
	}

	public getCertificates(context: BvTableCtxObject, callback: Function) {
		if (this.capability) {
			return this.capability.certificates.map(cc => cc.certificate);
		}

		VIPCertificateRest.list({
			page: context.currentPage,
			per_page: context.perPage,
			search: context.filter?.toString() ?? undefined,
			orderby: <VIPCertificateFields>context.sortBy ?? undefined,
			order: context.sortDesc ? "DESC" : "ASC",
			fk_project: this.project?.id || undefined,
			type: this.types,
			status: !this.hideFilters ? this.statuses : this.status ?? undefined,
			fk_ip: this.ips.length ? {
				values: this.ips,
				operator: "IN",
				relation: this.ips_relation,
			} : undefined,
			options: {
				project: this.project === null ? { manager: true } : false,
				ips: true,
			}
		}).then(result => {
			this.setResult(callback, result);
		});
		return null;
	}

	public viewCertificate(certificate: VIPCertificate) {
		this.$router.push({ name: "Certificate", params: { id: certificate.id.toString() } });
	}

	@Watch("types")
	public typesChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("statuses")
	public statusesChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("ips")
	public ipsChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("ips_relation")
	public ipsRelationChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}
}
